import type { Property } from 'csstype'
import styled from 'styled-components'

import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { MEDIA_QUERY } from '../../../styles'
import { MarginProps, margin, smMargin } from '../../../styles/margin'
import { PrefixedRecord } from '../../../styles/mediaProperties'
import { PaddingProps, padding, smPadding } from '../../../styles/padding'
import { Size } from '../../../styles/size'
import { sizePropertyValue } from '../../../styles/sizePropertyValue'

interface FlexBaseProps {
  alignItems?: Property.AlignItems
  justifyContent?: Property.JustifyContent
  gap?: number | Size
  direction?: Property.FlexDirection
  wrap?: Property.FlexWrap
}

interface FlexProps extends MarginProps, PaddingProps, FlexBaseProps, PrefixedRecord<'sm', FlexBaseProps> {}

export const Flex = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'alignItems',
      'justifyContent',
      'direction',
      'wrap',
      'gap',
      'mt',
      'mb',
      'mr',
      'ml',
      'pt',
      'pb',
      'pr',
      'pl',
      'm',
      'p'
    ].includes(prop) && !prop.startsWith('sm-')
})<FlexProps>`
  width: 100%;
  display: flex;
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  gap: ${({ gap = 0 }) => sizePropertyValue(gap)};
  flex-direction: ${({ direction = 'row' }) => direction};
  flex-wrap: ${({ wrap = 'nowrap' }) => wrap};
  ${margin}
  ${padding}
  @media ${MEDIA_QUERY.MOBILE} {
    ${smMargin}
    ${smPadding}
    justify-content: ${(props) => props['sm-justifyContent'] ?? props.justifyContent ?? 'flex-start'};
    align-items: ${(props) => props['sm-alignItems'] ?? props.alignItems ?? 'center'};
    gap: ${(props) => {
      if (isDefined(props['sm-gap'])) {
        return sizePropertyValue(props['sm-gap'])
      }

      return isDefined(props.gap) && sizePropertyValue(props.gap) ? sizePropertyValue(props.gap) : 0
    }};
    flex-direction: ${(props) => props['sm-direction'] ?? props.direction ?? 'row'};
    flex-wrap: ${(props) => props['sm-wrap'] ?? props.wrap ?? 'nowrap'};
  }
`
